import React from 'react';




const TextHome = () => {
    return (
        <header className="bg-white py-5">
            <div className="container px-5">
                <div className="row gx-5 align-items-center justify-content-center">
                    <div className="col-lg-8 col-xl-7 col-xxl-6">
                        <div className="my-5 text-center text-xl-start">
                            <h1 className="display-1 fw-bolder text-dark mb-2">SELL 4 U</h1>
                            <p className="lead fw-normal text-dark-50 mb-4">Sell projects for companies and GET you comision!</p>

                        </div>
                    </div>
                    <div className="col-xl-5 col-xxl-6 d-none d-xl-block text-center"><img className="img-fluid rounded-4 my-5" src="https://blog.travelpayouts.com/en/wp-content/uploads/sites/2/2019/11/sell-website.jpg" alt="..." /></div>
                </div>
            </div>
        </header>

    );
};

export default TextHome;